<div class="g-0">
    <!-- Secțiunea Date Beneficiar -->
    <div class="row">
        <div class="col-md">
            <div class="box-wrapper box-info">
                <div class="box-content-header">
                    <div class="row p-1">
                        <div class="col">
                            <mat-card-title>
                                <i class="fa-solid fa-user"></i>
                                <span>Date Beneficiar</span>
                            </mat-card-title>
                        </div>
                    </div>
                </div>
                <div class="box-content-body">
                    <table class="table table-condensed table-wrapper-box mb-0">
                        <tbody>
                            <tr>
                                <td width="40%" class="text-center">
                                    <strong><i class="fa-solid fa-id-card me-1"></i>Nume</strong>
                                </td>
                                <td class="text-left">{{ contract?.entity?.full_name || 'N/A' }}</td>
                            </tr>
                            <tr>
                                <td class="text-center">
                                    <strong><i class="fa-solid fa-fingerprint me-1"></i>CNP</strong>
                                </td>
                                <td class="text-left">{{ contract?.entity?.cnp || 'N/A' }}</td>
                            </tr>
                            <tr>
                                <td class="text-center">
                                    <strong><i class="fa-solid fa-location-dot me-1"></i>Adresă</strong>
                                </td>
                                <td class="text-left">{{ contract?.entity?.current_address || 'N/A' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>

    <!-- Secțiunea Programări Contractuale -->
    <div class="row mt-2" *ngIf="contract?.subcontracts?.length">
        <div class="col-md">
            <div class="box-wrapper box-programare" style="position: relative;">
                <div *ngIf="isUpdatingPrezenta" style="position: absolute; inset: 0; background: rgba(255,255,255,0.7); z-index: 10;
                       display: flex; align-items: center; justify-content: center; border-radius: inherit;">
                    <div class="d-flex flex-column align-items-center gap-2">
                        <mat-spinner [diameter]="40"></mat-spinner>
                        <span class="text-muted small">Se actualizează prezența...</span>
                    </div>
                </div>

                <div class="box-content-header" style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);">
                    <div class="row p-1">
                        <div class="col">
                            <div class="d-flex flex-row justify-content-between align-items-center">
                                <mat-card-title style="color: white;">
                                    <i class="fa-solid fa-layer-group"></i>
                                    <span>Programări Contractuale</span>
                                </mat-card-title>
                                <button type="button" class="btn btn-sm"
                                    style="background-color: rgba(255,255,255,0.15); color: white; border-color: rgba(255,255,255,0.4);"
                                    (click)="toggleAll()">
                                    <i class="fa-solid" [ngClass]="allExpanded ? 'fa-angles-up' : 'fa-angles-down'"></i>
                                    <span class="ms-1">{{ allExpanded ? 'Strânge tot' : 'Extinde tot' }}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="box-content-body p-0">
                    <ng-container *ngFor="let sub of contract?.subcontracts; let i = index">
                        <!-- Header subcontract -->
                        <div class="d-flex justify-content-between align-items-center px-3 py-2"
                            style="cursor: pointer; border-bottom: 1px solid #e0e0e0;"
                            [style.background-color]="expandedSubcontracts[i] ? '#f3f0fa' : 'white'"
                            (click)="toggleSubcontract(i)">
                            <div class="d-flex align-items-center flex-wrap gap-2">
                                <!-- <span>
                                    <i class="fa-solid fa-user-doctor me-1 text-primary"></i>
                                    <strong>{{ sub.programari[0].program_disponibil.nume_specialist || 'N/A' }}</strong>
                                </span> -->
                                <span class="badge bg-info text-dark">
                                    {{ sub.denumire_specializare || 'N/A' }}
                                </span>
                                <span class="badge bg-secondary">
                                    {{ sub.denumire_modul || 'N/A' }}
                                </span>
                                <span class="text-muted small">
                                    <i class="fa-solid fa-calendar-range me-1"></i>
                                    {{ formatDate(sub.date_from_sedinte) }} - {{ formatDate(sub.date_end_sedinte) }}
                                </span>
                                <span class="text-muted small">
                                    <i class="fa-solid fa-layer-group me-1"></i>
                                    {{ sub.programari.length || 0 }} / {{ sub.nr_sedinte }} ședințe
                                </span>
                            </div>
                            <div class="d-flex align-items-center gap-2" (click)="$event.stopPropagation()">
                                <!-- Buton edit subcontract — oprește propagarea click spre toggle -->
                                <button *ngIf="!sub.appointments_started" type="button" class="btn btn-sm btn-warning"
                                    (click)="editSubcontract(i)" title="Editează subcontract în tab nou">
                                    <i class="fa-solid fa-pen-to-square"></i>
                                    <span class="ms-1">Editează</span>
                                </button>
                                <i class="fa-solid text-secondary"
                                    [ngClass]="expandedSubcontracts[i] ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                            </div>
                        </div>

                        <!-- Tabel programări -->
                        <div *ngIf="expandedSubcontracts[i]" style="border-bottom: 2px solid #764ba2;">
                            <table class="table table-sm table-hover table-bordered mb-0">
                                <thead class="table-light">
                                    <tr>
                                        <th>Data</th>
                                        <th>Oră (Durată)</th>
                                        <th>Locație</th>
                                        <th>Specialist</th>
                                        <th>Tip problemă</th>
                                        <th>Status</th>
                                        <th class="text-center">Prezență</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let prog of sub.programari">
                                        <td>{{ formatDate(prog.date) }}</td>
                                        <td>
                                            {{ prog.time_from }} - {{ prog.time_end }}
                                            <span class="text-muted small">({{ prog.duration }} min)</span>
                                        </td>
                                        <td>{{ prog.program_disponibil.denumire_locatie || 'N/A' }}</td>
                                        <td>{{ prog.program_disponibil.nume_specialist || 'N/A' }}</td>
                                        <td>
                                            <span class="badge" style="background-color: #00bcd4; color: white;">
                                                {{ prog.program_disponibil.denumire_tip_problema || 'N/A' }}
                                            </span>
                                        </td>
                                        <td>
                                            <span class="badge" [ngClass]="getStatusClass(prog.status)">
                                                {{ prog.status_label }}
                                            </span>
                                        </td>
                                        <td class="text-center">
                                            <ng-container *ngIf="prog.status === 'in-asteptare'; else noPrezenta">
                                                <button type="button" class="btn btn-sm btn-outline-success me-1"
                                                    title="Prezent" (click)="updatePrezenta(prog.id, 'prezent')">
                                                    <i class="fa-solid fa-circle-check"></i>
                                                </button>
                                                <button type="button" class="btn btn-sm btn-outline-danger"
                                                    title="Absent" (click)="updatePrezenta(prog.id, 'absent')">
                                                    <i class="fa-solid fa-circle-xmark"></i>
                                                </button>
                                            </ng-container>
                                            <ng-template #noPrezenta>
                                                <span class="text-muted small fst-italic">—</span>
                                            </ng-template>
                                        </td>
                                    </tr>
                                    <tr *ngIf="!sub.programari.length">
                                        <td colspan="7" class="text-center text-muted fst-italic">
                                            Nu există programări pentru acest subcontract.
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>